import { createSelector } from '@reduxjs/toolkit';
import { FOfferType } from '../../../../packages/JsonQuery';
import { selectOfferType, selectTotalArea } from 'shared/selectors/jsonQuery';
import { selectTotalAreaLabel } from './selectTotalAreaLabel';

export const selectTotalAreaFilter = createSelector(
  [selectTotalArea, selectTotalAreaLabel, selectOfferType],
  ({ gte = null, lte = null }, label, offerType) => ({
    label,
    value: { min: gte ?? null, max: lte ?? null },
    unit: (offerType & FOfferType.CommercialLand) !== 0 ? 'сот.' : 'м²',
  }),
);
